<template>
  <div style="display: inline-block" class="mx-1">
    <b-icon
      icon="search"
      class="cursor-pointer"
      variant="primary"
      v-b-tooltip.hover
      :title="$t('sites.check-now')"
      @click="checkSite"
      v-if="!loading"
    />
    <b-icon icon="circle-fill" variant="primary" animation="throb" v-else />
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false
    };
  },
  props: {
    site: {
      type: Object,
      default: Object
    }
  },
  methods: {
    checkSite() {
      this.loading = true;
      this.$api.sites.checkSite(this.site.id).then(() => {
        this.$emit("refresh");
        setTimeout(() => {
          this.loading = false;
        }, 1000);
      });
    }
  }
};
</script>
